import { render, staticRenderFns } from "./AdSetting.vue?vue&type=template&id=a38f6274&scoped=true"
import script from "./AdSetting.vue?vue&type=script&lang=ts"
export * from "./AdSetting.vue?vue&type=script&lang=ts"
import style0 from "./AdSetting.vue?vue&type=style&index=0&id=a38f6274&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38f6274",
  null
  
)

export default component.exports